import axios from 'axios';
import toSnakeCaseThenStringify from '@/helpers/toSnakeCaseThenStringify';

export const state = () => ({});

export const getters = {};

export const mutations = {};

export const actions = {
    index(vuexContext, { range, accountId, interval, timeZone, properties }) {
        const params = {
            range,
            timeZone,
            interval,
            accountId,
            properties: toSnakeCaseThenStringify(properties)
        };

        return axios.getMethodOverridePost('/v1/dashboard/reach', { params, encodeURI: true });
    }
};
